/**

Coded by www.techhighway.ca

*/

const customRoutes = [
  // {
  //     "name": "Dashboard",
  //     "route": "dashboard_header",
  //     "order": 1,
  //     "indent": 1,
  //     "is_heading": 1
  // },
];

export default customRoutes;
